import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['properties_360', 'technical_inventories'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/technical_inventories`,
        }),
      }),
      makeQueryParams: makeListRequest({
        limitItemsRequest: 100,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties_360/technical_inventories',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.changeParamOnRouteParamsChange('property_id');
    basePlugin.changeParamOnRequestChange('property_id');
    basePlugin.changeParamWhenOpenSensors('property_id');
  });
};
